export default {
  getTickets(state) {
    return state.tickets
  }
}
